import { Position } from "geojson";
import { LotDTO } from "seedgreen-shared/dtos/LotDTO";
import { computed, ComputedRef, Ref } from "vue";

/**
 * Get a method for sorting lots
 */
export function useLotSortMethod(
	methodKey: Ref<LotSortMethodKey>,
): ComputedRef<LotSortMethod> {
	return computed(() => LotSortMethods[methodKey.value]);
}

export interface LotSortMethod {
	fn: (a: LotDTO, b: LotDTO, userPosition: Position | undefined) => number;
	label: string;
}
export const LotSortMethods = {
	distance: {
		label: "Distance",
		fn: (a: LotDTO, b: LotDTO, userPosition: Position | undefined) => {
			return userPosition
				? (a.distanceTo(userPosition) ?? Infinity) -
						(b.distanceTo(userPosition) ?? Infinity)
				: 0;
		},
	},
	name: {
		fn: (a: LotDTO, b: LotDTO) => {
			return a.name > b.name ? 1 : -1;
		},
		label: "Lot Name",
	},
	ranch: {
		fn: (a: LotDTO, b: LotDTO) => {
			return (a.ranchName || "\uFFFF")
				.trim()
				.localeCompare((b.ranchName || "\uFFFF").trim());
		},
		label: "Ranch",
	},
	grower: {
		fn: (a: LotDTO, b: LotDTO) => {
			return (a.growerName || "\uFFFF")
				.trim()
				.localeCompare((b.growerName || "\uFFFF").trim());
		},
		label: "Grower",
	},
};
export type LotSortMethodKey = keyof typeof LotSortMethods;
